import { useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import { FC, useCallback } from 'react';
import { $CurrentVideoArticle } from '@article/body/main/article-video/atoms';
import { LegacyHashtagItem } from '@article/shared/components/legacy-hashtag-item';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useTimeAgoFormatter } from '~/utils/format';
import { $CurrentArticleTranslated } from '@article/shared/atoms/current-article-translated';
import useReflowClick from '~/utils/use-reflow-click';
import { useActiveToCurrentArticle } from '@article/shared/utils/use-active-to-current-article';
import { ClickPosition } from '~/utils/click-position';
import { Link } from '@remix-run/react';
import { useViewTracking } from '~/utils/use-view-tracking';

import './style.scss';

interface IVideoContentFooterProps {
  folded: boolean;
}

export const VideoContentFooter: FC<IVideoContentFooterProps> = (props) => {
  const { t } = useTranslation();
  const articleTranslated = useAtomValue($CurrentArticleTranslated);
  const { folded } = props;
  const formatTimeAgo = useTimeAgoFormatter();
  const { forumList, locationInfo, modifyTime, publishTime, articleRegion } = useScopedAtomValue($CurrentVideoArticle);
  const activeToCurrentArticle = useActiveToCurrentArticle();

  const timeAgo = formatTimeAgo(modifyTime || publishTime);
  // add description for re-edit;
  const des = (Boolean(modifyTime) && t('article_bottom_time')) || '';
  // add space for slash-formatted-time and re-edited article
  const sep = timeAgo.includes('/') && des ? ' ' : '';
  const formattedTime = `${timeAgo}${sep}${des}`;

  const poiObservedRef = useViewTracking<HTMLAnchorElement>({
    onView: useCallback(() => {
      window.Tea('wap_cta_show', {
        current_position: ClickPosition.main_poi,
      });
    }, []),
  });

  const handlePoiClick = useReflowClick(
    {
      clickEvent: () => ({
        current_position: ClickPosition.main_poi,
        page_click_id: locationInfo?.poiId || '',
      }),
      reflowBehavior: () => {
        activeToCurrentArticle(ClickPosition.main_poi);
      },
    },
    [activeToCurrentArticle],
  );

  return (
    <div className="footer">
      {forumList && forumList.length > 0 && !articleTranslated && (
        <div className="video-hashtag-container">
          {forumList.map((forum) => (
            <LegacyHashtagItem key={forum.id} hashtag={forum} />
          ))}
        </div>
      )}
      {locationInfo && !folded && !articleTranslated && (
        <Link
          to={`/poi/${locationInfo.poiId}?region=${articleRegion}`}
          className="video-poi-container"
          style={{ maxWidth: '90%' }}
          onClick={handlePoiClick}
          ref={poiObservedRef}
        >
          <div className="video-poi-container-img" />
          <div className="video-poi-container-name">{locationInfo.poiName}</div>
        </Link>
      )}
      {!folded && (
        <div className="content-footer">
          <div className="article-time">{formattedTime}</div>
          <div className="mask-close-btn">{t('profile_fold')}</div>
        </div>
      )}
    </div>
  );
};
